import catalog from './portal-catalog.mjs'
export { catalog as PORTAL_CATALOG }
export const FOOTER_FIELDS = [
  ['companyName', '상호명', 120], ['representative', '대표자', 100], ['businessNumber', '사업자등록번호', 12],
  ['commerceNumber', '통신판매업신고번호', 100], ['trainingNumber', '원격훈련기관 지정번호', 100],
  ['address', '주소', 300], ['phone', '학습지원센터', 30], ['hours', '운영시간', 200],
]
export const MENU_TITLE_MAX = 30
const emptyFooter = () => Object.fromEntries(FOOTER_FIELDS.map(([key]) => [key, '']))
const control = text => [...text].some(char => { const code = char.codePointAt(0); return code < 32 || (code >= 127 && code <= 159) })
/** 순서를 매기는 묶음: 대메뉴, 같은 대메뉴의 하위 메뉴, 퀵메뉴, 푸터 링크(서버 MenuSettingService와 같다). */
export const siblingOf = row => row.kind === 'CHILD' ? `CHILD:${row.parent}` : row.kind
/** 포털 메뉴 기본값: 모두 표시, 원본 경로·이름, 카탈로그 순서. */
export function defaultMenuItems() {
  const counts = new Map()
  return catalog.map(row => { const group = siblingOf(row), order = counts.get(group) || 0; counts.set(group, order + 1); return { key: row.key, visible: true, target: null, title: null, order } })
}
export function defaultPortal() { return { revisionId: null, footer: emptyFooter(), items: defaultMenuItems() } }
export function defaultFooterSnapshot() { return { revisionId: null, footer: emptyFooter() } }
function revision(value) { if (value !== null && !/^[1-9][0-9]{0,18}$/.test(value)) throw new Error('INVALID_PORTAL_RESPONSE'); return value }
function footerOf(value) {
  const result = emptyFooter()
  for (const [key, , max] of FOOTER_FIELDS) { const text = value?.[key]; if (typeof text !== 'string' || [...text].length > max || control(text)) throw new Error('INVALID_PORTAL_RESPONSE'); result[key] = text }
  return result
}
/** 메뉴 설정 응답·입력 검증: 카탈로그 항목이 정확히 한 번씩, 허용 목록 안의 연결 경로, 30자 이하 이름, 묶음마다 0부터 빈틈 없는 순서. */
export function checkedMenuItems(input) {
  if (!Array.isArray(input) || input.length !== catalog.length) throw new Error('INVALID_PORTAL_RESPONSE')
  const items = new Map(input.map(row => [row?.key, row]))
  if (items.size !== catalog.length) throw new Error('INVALID_PORTAL_RESPONSE')
  const orders = new Map()
  const result = catalog.map(entry => {
    const row = items.get(entry.key)
    if (!row || typeof row.visible !== 'boolean' || (row.target !== null && !entry.targets?.includes(row.target)) || !Number.isInteger(row.order) || row.order < 0) throw new Error('INVALID_PORTAL_RESPONSE')
    if (row.title !== null && (typeof row.title !== 'string' || !row.title.trim() || [...row.title].length > MENU_TITLE_MAX || control(row.title))) throw new Error('INVALID_PORTAL_RESPONSE')
    const group = siblingOf(entry); if (!orders.has(group)) orders.set(group, new Set())
    if (orders.get(group).has(row.order)) throw new Error('INVALID_PORTAL_RESPONSE'); orders.get(group).add(row.order)
    return { key: entry.key, visible: row.visible, target: row.target, title: row.title, order: row.order }
  })
  for (const values of orders.values()) for (let index = 0; index < values.size; index++) if (!values.has(index)) throw new Error('INVALID_PORTAL_RESPONSE')
  return result
}
// 공개 DTO의 경로도 정본 허용 목록으로 검증한다. 서버 문안은 v-text/보간으로만 표시한다.
export function checkedPortal(value) {
  if (!value) throw new Error('INVALID_PORTAL_RESPONSE')
  return { revisionId: revision(value.revisionId), footer: footerOf(value.footer), items: checkedMenuItems(value.items) }
}
/** 관리자 사이트 정보·푸터 초안/게시 원문(메뉴 없음). */
export function checkedFooterSnapshot(value) {
  if (!value) throw new Error('INVALID_PORTAL_RESPONSE')
  return { revisionId: revision(value.revisionId), footer: footerOf(value.footer) }
}
/** 설정 순서대로 보이는 퀵메뉴·푸터 링크. 이름을 바꾼 항목은 바꾼 이름(custom=true)으로 돌려준다. */
export function portalLinks(value, kind) {
  const values = new Map(value.items.map(row => [row.key, row]))
  return catalog.filter(row => row.kind === kind && values.get(row.key)?.visible).sort((a, b) => values.get(a.key).order - values.get(b.key).order)
    .map(row => ({ ...row, title: values.get(row.key).title || row.title, custom: Boolean(values.get(row.key).title), to: values.get(row.key).target || row.to }))
}
